import { Component, OnInit , ViewChild, ElementRef} from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ApiService } from '../../api/api.service';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';


@Component({
  selector: 'app-otrform',
  templateUrl: './otrform.component.html',
  styleUrls: ['./otrform.component.css']
})
export class OtrformComponent implements OnInit {

  registerForm: any;
  submitted = false;
  fileArraData: any;

  public date = new Date().getDate();
  public month = new Date().getMonth() + 1;
  public year = new Date().getFullYear();
  public currentDate = this.date + '-' + this.month + '-' + this.year;

  datePickerConfig = {
    format: 'DD-MM-YYYY',
    max: this.currentDate,
  };

  constructor(private formBuilder: FormBuilder, private api: ApiService, private http: HttpClient) { }

  ngOnInit() {

    this.fileUploadForm = this.formBuilder.group({
      uploadedImage: ['']
    });

    this.api.liststate().subscribe((data:any)=>{
      this.state = data;
      //console.log(data);
    });

      this.registerForm = this.formBuilder.group({
          name: ['', Validators.required],
          gender: ['', Validators.required],
          dob: ['', Validators.required],
          fathername: ['', Validators.required],
          mobilenumber: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
          email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
          maritalstatus: ['', Validators.required],
          category: ['', Validators.required],
          divyang: ['', Validators.required],
          nationality: ['', Validators.required],
          doorno: ['', Validators.required],
          streetname: ['', Validators.required],
          area: ['', Validators.required],
          vtc: ['', Validators.required],
          pincode: ['', Validators.required],
          state: ['', Validators.required],
          district: ['', Validators.required],
          c_doorno: ['', Validators.required],
          c_streetname: ['', Validators.required],
          c_area: ['', Validators.required],
          c_vtc: ['', Validators.required],
          c_pincode: ['', Validators.required],
          c_state: ['', Validators.required],
          c_district: ['', Validators.required],
          pastexperience: [''],
          applypost: ['', Validators.required],
          image: ['', Validators.required],
          presently: ['', Validators.required],
          present: ['', Validators.required],
          relevent: ['', Validators.required],
          certificate: ['', Validators.required],
          resume: ['', Validators.required],
          acceptTerms: ['', Validators.required],
          qualification: this.formBuilder.array([]) ,
          professional:  this.formBuilder.array([]) ,
          workexp:  this.formBuilder.array([]) ,
          // name: ['', Validators.required],
          // gender: ['', Validators.required],
          // dob: ['', Validators.required],
          // fathername: ['', Validators.required],
          // mobilenumber: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
          // email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
          // maritalstatus: ['', Validators.required],
          // category: ['', Validators.required],
          // divyang: ['', Validators.required],
          // nationality: [''],
          // doorno: ['', Validators.required],
          // streetname: ['', Validators.required],
          // area: ['', Validators.required],
          // vtc: ['', Validators.required],
          // pincode: ['', Validators.required],
          // state: ['', Validators.required],
          // district: ['', Validators.required],
          // c_doorno: ['', Validators.required],
          // c_streetname: ['', Validators.required],
          // c_area: ['', Validators.required],
          // c_vtc: ['', Validators.required],
          // c_pincode: ['', Validators.required],
          // c_state: ['', Validators.required],
          // c_district: ['', Validators.required],
          // image: ['', Validators.required],
          // acceptTerms: [false, Validators.requiredTrue],
          // quantities: this.formBuilder.array([]) ,
      });

      this.addQualification();
  }

  public state:any;
  public district:any;

  onChangeState(data:any){
    //console.log(data.target.value);
    var myargs = {
      stateName: data.target.value
    }
    this.api.enterState(myargs).subscribe((result:any)=>{
      //console.log(JSON.stringify(result));
      this.district = result;
    });
  }


  handleFileInput(data:any){
    // console.log(data.target.files)
    // this.fileArraData = data.target.files[0];
    // console.log(this.fileArraData);

    if (data.target.files && data.target.files[0]) {
      const file = data.target.files[0];

      const reader = new FileReader();
      reader.onload = e => this.fileArraData = reader.result;

      reader.readAsDataURL(file);
  }
  }
  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }

  onSubmit() {
      this.submitted = false;



    console.log(this.registerForm.value);
      this.api.otrPersonalForm(this.registerForm.value).subscribe((result:any)=>{
        //console.log(this.aFormGroup.controls);
        console.log(result);
      });


      // stop here if form is invalid
      if (this.registerForm.invalid) {
          return;
      }

      // display form values on success
      alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.registerForm.value, null, 4));

  }

  onReset() {
      this.submitted = false;
      this.registerForm.reset();
  }

  newQuantity(): FormGroup {
    return this.formBuilder.group({
      exampassed: '',
      yearpass: '',
      university: '',
      substudied: '',
      marks: '',

    })
  }


  qualification() : FormArray {
    return this.registerForm.get("qualification") as FormArray
  }

  addQualification() {
    this.qualification().push(this.newQuantity());
  }

  removeQualification(i:number) {
    this.qualification().removeAt(i);
  }



  get skills() : FormArray {
    return this.registerForm.get("skills") as FormArray
  }

  newSkill(): FormGroup {
    return this.formBuilder.group({
      examination_name: '',
      year_of_passing: '',
      name_of_university: '',
      sub_studied: '',
      division_of_marks: '',
    })
 }

 addSkills() {
  this.skills.push(this.newSkill());
}

removeSkill(i:number) {
  this.skills.removeAt(i);
}

// prof...

newprofessional(): FormGroup {
  return this.formBuilder.group({
    exampassed: '',
    yearpass: '',
    course: '',
    university: '',
    substudied: '',
    marks: '',

  })
}


professional() : FormArray {
  return this.registerForm.get("professional") as FormArray
}

addprofessional() {
  this.professional().push(this.newprofessional());
}

removeprofessional(i:number) {
  this.professional().removeAt(i);
}



get professionalskills() : FormArray {
  return this.registerForm.get("professional") as FormArray
}

professionalnewSkill(): FormGroup {
  return this.formBuilder.group({
    examination_name: '',
    year_of_passing: '',
    details_of_course: '',
    name_of_university: '',
    sub_studied: '',
    division_of_marks: '',
  })
}

professionaladdSkills() {
this.skills.push(this.newprofessional());
}

professionalremoveSkill(i:number) {
this.skills.removeAt(i);
}

//Work Exp

newworkexp(): FormGroup {
  return this.formBuilder.group({
    addressofemp: '',
    from: '',
    to: '',
    scaleofpay: '',
    service: '',
    naturework: '',

  })
}


workexp() : FormArray {
  return this.registerForm.get("workexp") as FormArray
}

addworkexp() {
  this.workexp().push(this.newworkexp());
}

removeworkexp(i:number) {
  this.workexp().removeAt(i);
}



get workexpskills() : FormArray {
  return this.registerForm.get("workexp") as FormArray
}

workexpnewSkill(): FormGroup {
  return this.formBuilder.group({
    examination_name: '',
    year_of_passing: '',
    details_of_course: '',
    name_of_university: '',
    sub_studied: '',
    division_of_marks: '',
  })
}

workexpaddSkills() {
this.skills.push(this.newworkexp());
}

workexpremoveSkill(i:number) {
this.skills.removeAt(i);
}

@ViewChild('UploadFileInput', { static: false }) uploadFileInput: any;
fileUploadForm: any;
fileInputLabel: any;

onFileSelect(event:any) {
  const file = event.target.files[0];
  this.fileInputLabel = file.name;
  this.fileUploadForm.get('uploadedImage').setValue(file);
  console.log(file);
}

onFormSubmit(){
  console.log(this.fileUploadForm.uploadedImage)
  if (!this.fileUploadForm.get('uploadedImage').value) {
    alert('Please fill valid details!');
    return;
  }

  const formData = new FormData();
  formData.append('uploadedImage', this.fileUploadForm.get('uploadedImage').value);
  formData.append('agentId', '007');

console.log("formData: " + JSON.stringify(formData));

  this.http.post<any>('http://localhost:5001/uploadfile', formData).subscribe(response => {
      console.log(response.uploadedFile.path);
      this.registerForm.image.setValue(response.uploadedFile.path);

      if (response.statusCode === 200) {
        // Reset the file input
        this.uploadFileInput.nativeElement.value = "";
        this.fileInputLabel = undefined;
      }
    }, er => {
      console.log(er);
      alert("undefined: " + er.error.error);
    });
}

omit_text(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_text_number(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_email(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 46 || k==64 || k==95 || k==32);
}
omit_number(event:any)
{
  var k;
   k = event.charCode;
   return((k >= 48 && k <= 57) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_spl(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 47 || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_addres(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_decimal(event:any)
{
  var k;
   k = event.charCode;
   return((k >= 48 && k <= 57) || k==32 || k == 46);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}

public dup_doorno:any;
public dup_street:any;
public dup_area:any;
public dup_vtc:any;
public dup_pincode:any;
public dup_state:any;
public dup_district:any;
public bool_crntAddress:boolean = false;

onChangeDist(event:any){
  this.bool_crntAddress = true;
}
onChangeAddress(event:any){
  if(event.target.value == 'yes'){

    this.dup_doorno = this.registerForm.value.doorno;
    this.dup_street = this.registerForm.value.streetname;
    this.dup_area = this.registerForm.value.area;
    this.dup_vtc = this.registerForm.value.vtc;
    this.dup_pincode = this.registerForm.value.pincode;
    this.dup_state = this.registerForm.value.state;
    this.dup_district = this.registerForm.value.district;


    return;
  }
  else{
    this.dup_doorno = "";
    this.dup_street = "";
    this.dup_area = "";
    this.dup_vtc = "";
    this.dup_pincode = "";
    this.dup_state = "";
    this.dup_district = "";
    return;
  }

}
}
